<div class="invitations">
  <p class="invitations__intro text-gray-500 line-height-3 mt-0" data-clarity-unmask="true">
    Kursanci, którzy mieli już konto, dołączają do ośrodka dopiero po przyjęciu zaproszenia - do tego czasu widzisz
    tylko adres e-mail. Na odpowiedź mają 14 dni; zarezerwowany abonament wraca do puli, gdy zaproszenie zostanie
    odrzucone, wygaśnie albo je wycofasz.
  </p>

  <p *ngIf="loadError" class="error-message">
    Nie udało się pobrać zaproszeń.
    <p-button label="Spróbuj ponownie" [link]="true" size="small" (onClick)="load()" data-clarity-unmask="true" />
  </p>

  <p-table [value]="invitations" [loading]="loading" dataKey="guid" styleClass="p-datatable-sm"
    [tableStyle]="{ 'min-width': '52rem' }">
    <ng-template pTemplate="header">
      <tr data-clarity-unmask="true">
        <th>Adres e-mail</th>
        <th>Status</th>
        <th>Wysłane</th>
        <th>Ważne do</th>
        <th>Abonament</th>
        <th>Wysłane przez</th>
        <th class="text-right">Akcje</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invitation>
      <tr>
        <td>{{ invitation.email }}</td>
        <td>
          <span class="invitation-status" [ngClass]="'invitation-status--' + invitation.status">
            {{ statusLabel(invitation) }}
          </span>
        </td>
        <td>{{ formatDate(invitation.createdUtc) }}</td>
        <td>{{ isPending(invitation) ? formatDate(invitation.expiresUtc) : '—' }}</td>
        <td>{{ invitation.subscriptionPlanName || '—' }}</td>
        <td>{{ invitation.createdByDisplayName || '—' }}</td>
        <td class="text-right white-space-nowrap">
          <ng-container *ngIf="isPending(invitation)">
            <p-button icon="pi pi-send" [text]="true" [rounded]="true" pTooltip="Wyślij ponownie"
              tooltipPosition="top" ariaLabel="Wyślij zaproszenie ponownie" [loading]="busyGuid === invitation.guid"
              [disabled]="busyGuid !== null" (onClick)="resend(invitation)" data-clarity-unmask="true" />
            <p-button icon="pi pi-times" [text]="true" [rounded]="true" severity="danger" pTooltip="Wycofaj"
              tooltipPosition="top" ariaLabel="Wycofaj zaproszenie" [disabled]="busyGuid !== null"
              (onClick)="cancel(invitation)" data-clarity-unmask="true" />
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center text-gray-500 py-4" data-clarity-unmask="true">
          Nie ma zaproszeń z ostatnich 30 dni.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog key="studentInvitationConfirm" [style]="{ width: '480px' }" appendTo="body"></p-confirmDialog>
